var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cmg-rewards-extras"},[_c('cmg-rewards-extras-header',{attrs:{"achievements":_vm.achievements}}),_c('cmg-rewards-extras-body',{attrs:{"campaigns":_vm.campaigns}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }